// extracted by mini-css-extract-plugin
export default {"close-container":"CloseBtn_close-container__UESzz","leftright":"CloseBtn_leftright__lOKGP","rightleft":"CloseBtn_rightleft__bhL+0","close":"CloseBtn_close__yl7u2"};